/* __next_internal_client_entry_do_not_use__ SearchPagePerformanceTrackingWrapper,useSearchPageNonPrimaryContentDeferRender,useSearchPagePerformanceTrackingRefCallback auto */ import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { jsx as _jsx } from "react/jsx-runtime";
import { useNextRouterContext } from "@faire/retailer-visitor-shared/app/_lib/routing/NextRouterContext";
import { useZustandLocation } from "@faire/retailer-visitor-shared/app/_lib/routing/useZustandLocation";
import { SDUIUPLTWrapper } from "@faire/retailer-visitor-shared/components/SDUI/UPLT/SDUIUPLTWrapper";
import { PageInitialized } from "@faire/retailer-visitor-shared/events";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { shouldShowRscProductTileLoggedInSearchPage } from "@faire/retailer-visitor-shared/settings/getSettingRscProductTileLoggedInSearchPage";
import { useSearchPageShowNoProductResults } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageShowNoProductResults";
import { useSearchPageFiltersIsLoading } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Filters/useSearchPageFiltersIsLoading";
import { useSearchPageQueryDataUpdatedAt } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageQueryDataUpdatedAt";
import { useSearchPageQueryIsError } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageQueryIsError";
import { useSearchPageQueryIsLoading } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageQueryIsLoading";
import { useSearchPageQueryQueryKey } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageQueryKey";
import { useSearchPageIsFromDiscoverURL } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageIsFromDiscoverURL";
import { useSearchPageProductSearchString } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageProductSearchString";
import { useSearchPageActionName } from "@faire/retailer-visitor-shared/views/search-v2/util/useSearchPageActionName";
import { markPageJsExecuted } from "@faire/web--source/common/performance/TrackPerformanceBreakdown/markPageJsExecuted";
import { UserPerceivedLoadTimingContext } from "@faire/web--source/common/performance/userPerceivedLoadTiming/UserPerceivedLoadTimingContext";
import { trackRetailersPageViewView } from "@faire/web-api--source/events/retailers/view/pageView";
import { WebClientSize } from "@faire/web-api--source/indigofair/data/WebClientSize";
import productPage from "@faire/web-api--source/routes/product/productToken";
import React, { useContext, useEffect, use } from "react";
var PAGE_JS_EXECUTED_MARK = markPageJsExecuted();
var NUM_COMPONENTS = 1;
var _obj;
var NUM_COMPONENTS_PER_CLIENT_SIZE = (_obj = {}, _define_property(_obj, WebClientSize.MOBILE, NUM_COMPONENTS), _define_property(_obj, WebClientSize.TABLET, NUM_COMPONENTS), _define_property(_obj, WebClientSize.DESKTOP, NUM_COMPONENTS), _define_property(_obj, WebClientSize.XLARGE_DESKTOP, NUM_COMPONENTS), _define_property(_obj, WebClientSize.WEB_CLIENT_SIZE_UNKNOWN, NUM_COMPONENTS), _obj);
// Changes to UPLT tracking should also be made in useSearchPagePerformanceTracking.ts and LoggedInSearchPageSDUIUPLTWithContext.tsx
export var SearchPagePerformanceTrackingWrapper = function(param) {
    var children = param.children;
    var isFromDiscoverURL = useSearchPageIsFromDiscoverURL();
    var isProductsLoading = useSearchPageQueryIsLoading();
    var isFiltersLoading = useSearchPageFiltersIsLoading();
    var isLoading = isProductsLoading || isFiltersLoading;
    var showNoProductResults = useSearchPageShowNoProductResults();
    var isError = useSearchPageQueryIsError();
    var queryKey = useSearchPageQueryQueryKey();
    var dataUpdatedAt = useSearchPageQueryDataUpdatedAt();
    var queryString = useSearchPageProductSearchString();
    var pathname = useZustandLocation(function(state) {
        return state.pathname;
    }).pathname;
    var _useNextRouterContext = useNextRouterContext(), nextPrefetch = _useNextRouterContext.prefetch;
    var queryKeyString = JSON.stringify(queryKey);
    var name = useSearchPageActionName();
    var isLoggedIn = useIsLoggedInRetailer();
    useEffect(function() {
        if (!isLoading) {
            PageInitialized.publish();
        }
    }, [
        isLoading
    ]);
    useEffect(function() {
        if (!isLoading) {
            trackRetailersPageViewView("", "", queryString !== null && queryString !== void 0 ? queryString : "", isFromDiscoverURL ? "discover" : "search", pathname, name);
        }
    }, [
        isLoading,
        isFromDiscoverURL,
        queryString,
        pathname,
        name
    ]);
    var handlePageIsInteractive = function() {
        nextPrefetch(productPage("productToken"));
    };
    return /*#__PURE__*/ _jsx(SDUIUPLTWrapper, {
        name: name,
        numComponentsPerClientSize: NUM_COMPONENTS_PER_CLIENT_SIZE,
        enableTrackPerformanceBreakdown: "internal-tracking",
        shouldUseWaitForImagesToLoadPromise: isLoggedIn,
        pageJsExecutedMark: PAGE_JS_EXECUTED_MARK,
        isPageLoading: isLoading && !isError,
        dataUpdatedAt: dataUpdatedAt,
        pageLoadKey: queryKeyString,
        onImageLoad: handlePageIsInteractive,
        enabled: true,
        ignoreImages: showNoProductResults || isError,
        children: children
    });
};
// Defer rendering until critical components are loaded
export var useSearchPageNonPrimaryContentDeferRender = function() {
    var shouldDeferRender = shouldShowRscProductTileLoggedInSearchPage();
    var renderNonPrimaryContentPromise = useContext(UserPerceivedLoadTimingContext).renderNonPrimaryContentPromise;
    if (shouldDeferRender) {
        // use will wait for the promise to resolve before rendering the component
        // and render suspense fallback if the promise is not resolved yet
        use(renderNonPrimaryContentPromise);
    }
};
export var useSearchPagePerformanceTrackingRefCallback = function() {
    var _useContext;
    var _useContext_refCallback;
    return (_useContext_refCallback = (_useContext = useContext(UserPerceivedLoadTimingContext)) === null || _useContext === void 0 ? void 0 : _useContext.refCallback) !== null && _useContext_refCallback !== void 0 ? _useContext_refCallback : emptyRefCallback;
};
function emptyRefCallback() {}
